export const ADJECTIVES: ReadonlyArray<string> = [
  "Vivid", "Quiet", "Lucky", "Sleepy", "Brave", "Witty", "Cosmic", "Sunny",
  "Misty", "Eager", "Jolly", "Plucky", "Curious", "Frosty", "Lively", "Snappy",
  "Cheery", "Mellow", "Spicy", "Wandering", "Velvet", "Glowing", "Drifting",
  "Bouncy", "Plump", "Crisp", "Tidy", "Earnest", "Modest", "Honest",
];

export const ANIMALS: ReadonlyArray<string> = [
  "Capybara", "Otter", "Fox", "Owl", "Octopus", "Lemur", "Sloth", "Hedgehog",
  "Penguin", "Dolphin", "Quokka", "Turtle", "Narwhal", "Tapir", "Beaver",
  "Pangolin", "Wombat", "Manatee", "Axolotl", "Marmot", "Tanuki", "Whale",
  "Bumblebee", "Heron", "Kakapo", "Toucan", "Magpie", "Lynx", "Stoat", "Stork",
];

export const ICONS: ReadonlyArray<string> = [
  "🦊", "🐢", "🐙", "🐳", "🦉", "🐝", "🦄", "🐼",
  "🦔", "🦦", "🐧", "🦩", "🐉", "🦕", "🐡", "🦋",
  "🌵", "🌻", "🍄", "🌈", "⛺", "🚀", "🎈", "🍩",
  "🌮", "🍕", "🥑", "🧃", "☕", "🎲", "🎷", "📷",
];

const ICONS_SET = new Set(ICONS);

export function isCuratedIcon(icon: string): boolean {
  return ICONS_SET.has(icon);
}

function pickRandom<T>(list: ReadonlyArray<T>): T {
  return list[Math.floor(Math.random() * list.length)] as T;
}

export function generateName(): string {
  return `${pickRandom(ADJECTIVES)} ${pickRandom(ANIMALS)}`;
}

export function generateIcon(): string {
  return pickRandom(ICONS);
}
